/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrderCancelDto } from '../../models/order-cancel-dto';
import { OrderDto } from '../../models/order-dto';

export interface OrderControllerCancel$Params {

/**
 * 주문 ID
 */
  id: string;
      body: OrderCancelDto
}

export function orderControllerCancel(http: HttpClient, rootUrl: string, params: OrderControllerCancel$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderDto>> {
  const rb = new RequestBuilder(rootUrl, orderControllerCancel.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrderDto>;
    })
  );
}

orderControllerCancel.PATH = '/api/orders/{id}/cancel';
